import React from 'react';
import { motion } from 'framer-motion';
import { Facebook, Instagram, Linkedin, MessageCircle, Mail } from 'lucide-react';

const FounderSection = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 25 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    const socialLinks = [
        { id: 1, icon: <Facebook size={16} />, url: "#" },
        { id: 2, icon: <Instagram size={16} />, url: "#" },
        { id: 3, icon: <Linkedin size={16} />, url: "#" },
        { id: 4, icon: <MessageCircle size={16} />, url: "#" },
        { id: 5, icon: <Mail size={16} />, url: "#" }
    ];

    return (
        <section className="w-full bg-[#FFFFFF] py-16 lg:py-24 overflow-hidden select-none text-left relative z-50">
            <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    className="flex lg:flex-row flex-col gap-10 lg:gap-16 items-center w-full"
                >

                    <motion.div
                        variants={itemVariants}
                        className="lg:max-w-[596px] w-full relative lg:min-h-[366px] min-h-auto bg-[#E3DFF1] overflow-hidden rounded-none shadow-[0_10px_30px_rgba(0,0,0,0.01)]"
                    >
                        <div className="absolute top-[20px] left-[20px] bg-white/80 border border-[#D5CAFF] px-3 py-1.5 rounded-[8px] shadow-xs z-20">
                            <span className="text-[#01386A] font-sora font-[600] text-[14px] sm:text-[16px] uppercase tracking-wider">
                                CEO & FOUNDER
                            </span>
                        </div>

                        <img
                            src="/assets/customer/item1.png"
                            alt="Michael Reynolds - CEO & Founder"
                            className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[85%] h-auto object-contain z-10 transition-transform duration-500 hover:scale-103"
                        />
                    </motion.div>

                    <motion.div
                        variants={itemVariants}
                        className="lg:col-span-7 flex flex-col items-start w-full"
                    >
                        <div className="w-full relative pb-8 mb-6 border-b border-gray-200/60">
                            <span className="text-[#49577A] text-[44px] font-sora leading-none absolute -top-5 -left-1 select-none">
                                “
                            </span>
                            <p className="text-[#49577A] text-[14px] lg:text-[16px] leading-relaxed font-[500] font-graphik pl-6 relative z-10">
                                Founder and Chief Executive Officer responsible for defining the company's long-term vision and strategic direction. Leads executive decision-making, drives innovation, and ensures sustainable growth across all business areas.”
                            </p>
                        </div>

                        <h3 className="text-[#01386A] font-[600] font-sora text-[16px] lg:text-[20px] tracking-tight leading-none mb-6">
                            Michael Reynolds
                        </h3>

                        <div className="flex items-center gap-3">
                            {socialLinks.map((link) => (
                                <a
                                    key={link.id}
                                    href={link.url}
                                    className="w-9 h-9 border border-[#01386A] text-[#01386A] rounded-[8px] flex items-center justify-center transition-all duration-300 hover:bg-[#01386A] hover:text-white active:scale-95 shadow-2xs"
                                >
                                    {link.icon}
                                </a>
                            ))}
                        </div>

                    </motion.div>

                </motion.div>

            </div>
        </section>
    );
};

export default FounderSection;